import { render, staticRenderFns } from "./DiffInCostConfirm.vue?vue&type=template&id=8edfbaca&scoped=true&"
import script from "./DiffInCostConfirm.vue?vue&type=script&lang=js&"
export * from "./DiffInCostConfirm.vue?vue&type=script&lang=js&"
import style0 from "./DiffInCostConfirm.vue?vue&type=style&index=0&id=8edfbaca&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8edfbaca",
  null
  
)

export default component.exports